export default __webpack_public_path__ + "static/media/maxine_detail11.e18aa9e7.jpg";